import React from "react";

import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";
import { isMobile } from "react-device-detect";

class LoginWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userContext: this.props.userContext,
            username: this.props.username !== undefined && this.props.username !== "undefined" ? this.props.username : "",
            showPassword: false

        };
        this.recaptchaHandlerId;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAccountsClick = this.handleAccountsClick.bind(this);
        this.showPassword = this.showPassword.bind(this);
        this.loginUser = this.loginUser.bind(this);
    }

    componentDidMount() {
        if (!this.state.userContext && GBEglobal.settings.iovation !== undefined && GBEglobal.settings.iovation.enabled) {
            this.loadIovationScript();
        }

        if (isMobile && !this.props.isLoggedIn && (localStorage.inputUsername && localStorage.inputUsername !== "undefined") && localStorage.rememberUsername && JSON.parse(localStorage.rememberUsername) !== false) {
            this.setState({
                username: localStorage.inputUsername
            });
        }
    }

    handleOnBlur(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-widget", eventAction: "click", eventLabel: value });
    }

    loginUser(event, value) {
        event.preventDefault();

        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-widget", eventAction: "click", eventLabel: value });
        var thisComponent = this;
        const reCaptchaGtvValue = GBEglobal.settings["system.reCAPTCHA.RequiredForEstablishSession"];
        const reCaptchaEnabled = ((typeof reCaptchaGtvValue === "string" && reCaptchaGtvValue.toLowerCase() === "true") || reCaptchaGtvValue === true);
        if (reCaptchaEnabled !== undefined && reCaptchaEnabled && configurationSettings.reCaptchaSiteKey) {
            if (thisComponent.recaptchaHandlerId === undefined) {
                thisComponent.recaptchaHandlerId = window.grecaptcha.render("irecaptcha", {
                    "sitekey": configurationSettings.reCaptchaSiteKey,
                    "size": "invisible",
                    "callback": function (token) {
                        thisComponent.props.onLoginRequest({
                            username: thisComponent.state.username,
                            password: thisComponent.state.password,
                            reCAPTCHAToken: token
                        });
                    },
                    "expired-callback": function () {
                        window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                    }
                });
                window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
            } else {
                window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
            }
        } else {
            thisComponent.props.onLoginRequest({
                username: thisComponent.state.username,
                password: thisComponent.state.password
            });
        }
    }

    loadIovationScript() {
        const iSettings = document.createElement("script");
        iSettings.type = "text/javascript";
        iSettings.innerText = "window.io_global_object_name = 'IGLOO';";
        iSettings.innerText += "window.IGLOO = window.IGLOO || {";
        iSettings.innerText += "   'enable_flash': false,";
        iSettings.innerText += "    'bbout_element_id': 'ioBB',";
        iSettings.innerText += "    'loader': {";
        iSettings.innerText += "        'version': 'general5'";
        iSettings.innerText += "  }};";
        iSettings.id = "iovation-settings";
        document.body.appendChild(iSettings);

        const iScript = document.createElement("script");
        iScript.type = "text/javascript";
        iScript.src = configurationSettings.baseUrl + "Libs/iovation/loader.js";
        iScript.id = "iovation-loader";
        document.body.appendChild(iScript);
    }

    onGuestSelected() {

        this.setState({
            userContext: null
        });

        this.props.onHideLoginWidget();
    }

    closePopup(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-widget", eventAction: "click", eventLabel: value });

        this.setState({
            userContext: null
        });

        this.props.onHideLoginWidget();
    }

    handleInputChange(e) {
        this.setState({
            [e.currentTarget.name]: e.currentTarget.value
        });
    }

    handleAccountsClick(page) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-widget", eventAction: "click", eventLabel: page });
        this.props.onAccountClicked(page);
    }

    showPassword() {
        this.setState({
            showPassword: !this.state.showPassword
        });
    }

    rememberUsername(e) {
        localStorage.setItem("rememberUsername", e.target.checked);
        this.setState({});
    }

    render() {
        let mobileSizing = "9";
        let isPasswordVisible = "password";
        let hasRememberUsername;
        let isChecked = "";

        if (configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" && isMobile) {
            isPasswordVisible = this.state.showPassword ? "text" : "password";
            hasRememberUsername = true;
            mobileSizing = "12";
            isChecked = localStorage.rememberUsername && JSON.parse(localStorage.rememberUsername) !== false ? true : false;
        }

        return (
            <ErrorBoundary componentName="LoginWidget">
                {this.props.showLoginWidget &&
                    <div className="loginWidget">
                        <div className="mask">
                        </div>
                        <form name="loginForm" id="loginForm" onSubmit={(e) => this.loginUser(e, "login")}>
                            <div className="row mb-3">
                                <div className="col-10">
                                    <h1>Please log in below</h1>
                                </div>
                                <div className="col-2 text-right">
                                    <a href="#" className="closePopup" onClick={this.closePopup.bind(this, "close-popup")}>X</a>
                                </div>
                            </div>
                            <div className="pl-4">
                                <div className="row align-items-center inputContainer">

                                    <div className="col-3 form-group">
                                        Username:
                                    </div>
                                    <div className={"col-" + mobileSizing + " form-group"}>
                                        <input id="username" name="username" type="text" className="form-control" placeholder="Email/Username" autoCapitalize="none" defaultValue={this.state.username}
                                            required pattern=".{1,}" onChange={this.handleInputChange} onBlur={this.handleOnBlur.bind(this, "username")} />
                                    </div>
                                </div>
                                <div className="row align-items-center inputContainer">
                                    <div className="col-3 form-group">
                                        Password:
                                    </div>
                                    <div className={"col-" + mobileSizing + " form-group"}>
                                        <input id="password" name="password" type={isPasswordVisible} className="form-control" placeholder="Password" autoCapitalize="none" autoComplete="off" defaultValue={this.props.password}
                                            onChange={this.handleInputChange} />

                                        {configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" && isMobile &&
                                            <span className="showPassword" onClick={this.showPassword} dangerouslySetInnerHTML={{ __html: this.state.showPassword ? "Hide" : "Show" }} />
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col form-group text-right">

                                        {hasRememberUsername &&
                                            <>
                                                <input type="checkbox" id="rememberUsernameInput" defaultChecked={isChecked} onClick={this.rememberUsername.bind(this)} style={{ marginRight: "5px" }} />
                                                <span className="rememberUsername">Remember Username</span>
                                            </>
                                        }
                                        <div></div>
                                        <button type="submit" id="btnLogin" value="Login" className="btn btn-primary">
                                            Login
                                            {configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" &&
                                                <span className="secure-icon"></span>
                                            }
                                        </button>
                                        {isMobile && !this.props.hideJoinNowButton &&
                                            <>
                                                <button type="button" onClick={this.handleAccountsClick.bind(this, "joinnow")} className="join-now-button btn btn-primary ml-1 btn-login">Join Now</button>
                                                {configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" &&
                                                    <span className="new-text">New to Betdaq?</span>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row popupFooter">
                                <div className="col form-group text-right">
                                    Forgot your <a href="#" onClick={this.handleAccountsClick.bind(this, "forgottenUsername")}>username</a> / <a href="#" onClick={this.handleAccountsClick.bind(this, "forgottenPassword")}>password</a> ? {!isMobile && !this.props.hideJoinNowButton && <a href="#" onClick={this.handleAccountsClick.bind(this, "joinnow")} className="ml-3">Join Now</a>}
                                </div>
                            </div>
                            {!this.state.userContext && GBEglobal.settings["iovation"] !== undefined && GBEglobal.settings["iovation"]["enabled"] === true &&
                                <input type="text" name="ioBB" id="ioBB" className="d-none" />
                            }
                        </form>
                    </div>
                }
            </ErrorBoundary>
        );
    }
}

export { LoginWidget };